module.exports = __webpack_public_path__ + "img/title-3.58f1fef0.png";